import type { InputSource } from './types';

export const calibrationCard: InputSource = {
  label: 'Calibration',
  value: 'calibrationCard',
  draw: (ctx, width, height) => {
    ctx.clearRect(0, 0, width, height);
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, width, height);

    const minDim = Math.min(width, height);
    const margin = Math.round(minDim * 0.02);
    const borderWidth = Math.max(6, Math.round(minDim * 0.005));

    ctx.strokeStyle = 'rgba(200, 200, 200, 0.85)';
    ctx.lineWidth = borderWidth;
    ctx.strokeRect(margin, margin, width - margin * 2, height - margin * 2);

    ctx.strokeStyle = 'rgba(170, 170, 170, 0.7)';
    ctx.lineWidth = Math.max(2, Math.round(minDim * 0.002));
    ctx.beginPath();
    ctx.moveTo(width * 0.5, margin);
    ctx.lineTo(width * 0.5, height - margin);
    ctx.moveTo(margin, height * 0.5);
    ctx.lineTo(width - margin, height * 0.5);
    ctx.stroke();

    const markerSize = Math.max(24, Math.round(minDim * 0.06));
    ctx.strokeStyle = 'rgba(190, 190, 190, 0.8)';
    ctx.lineWidth = Math.max(3, Math.round(minDim * 0.003));
    ctx.strokeRect(margin, margin, markerSize, markerSize);
    ctx.strokeRect(width - margin - markerSize, margin, markerSize, markerSize);
    ctx.strokeRect(margin, height - margin - markerSize, markerSize, markerSize);
    ctx.strokeRect(width - margin - markerSize, height - margin - markerSize, markerSize, markerSize);

    ctx.fillStyle = 'rgba(185, 185, 185, 0.9)';
    ctx.font = `bold ${Math.round(minDim * 0.09)}px Arial, sans-serif`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText('PROJ', width * 0.5, height * 0.5);
  },
};
